module.exports = __webpack_public_path__ + "static/media/webdevelopment.606f0cd7.png";